export default "__VITE_ASSET__B46eoSt4__"